import React from 'react';

function NoVisit() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Previous Visit Found</p>
			</div>
		</div>
	);
}
export default NoVisit;
